import { Component, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-manufacturedhomes',
    templateUrl: './manufacturedhomes.component.html',
    styleUrls: ['./manufacturedhomes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManufacturedhomesComponent implements OnInit, AfterViewInit {

  id: number;

  constructor(private actRoute: ActivatedRoute) {
      this.id = this.actRoute.snapshot.params.id;
    }

  ngAfterViewInit() {
      console.log(this.id);
    }
  ngOnInit() {
  }

}
